import script from "./ResponsesIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsesIcon.vue?vue&type=script&setup=true&lang=js"

import "./ResponsesIcon.vue?vue&type=style&index=0&id=352a370d&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-352a370d"]])

export default __exports__